import { render } from "./ProductListTable.vue?vue&type=template&id=3c9fbc31"
import script from "./ProductListTable.vue?vue&type=script&lang=js"
export * from "./ProductListTable.vue?vue&type=script&lang=js"

import "./ProductListTable.vue?vue&type=style&index=0&id=3c9fbc31&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__